<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model ref="form" :model="model.constructionDetail" :rules="validatorRules" slot="detail" :colon="false">
        <Detail ref="detailRef" v-show="showDetail" />
        <a-row :gutter="24">

           <a-col :span="8">
            <a-form-model-item :label="$t('是否存在设计变更')" prop="isDesignChanges">
              <a-radio-group v-model="model.constructionDetail.isDesignChanges">
                <a-radio :value="1">{{ $t('是') }}</a-radio>
                <a-radio :value="0">{{ $t('否') }}</a-radio>
              </a-radio-group>
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item :label="$t('施工附件')">
              <JUpload v-model="fileList" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange"/>
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item :label="$t('验收附件')">
              <JUpload v-model="fileList2" accept=".pdf,.doc,.docx,.xls,.xlsx" @change="uploadChange2"/>
            </a-form-model-item>
          </a-col>
         
        </a-row>
        <a-row :gutter="24">
          <a-col :span="24">
            <a-form-model-item :label="$t('施工备注')" prop="constructionRemark">
              <a-textarea v-model="model.constructionDetail.constructionRemark" :placeholder="$t('请输入施工备注')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>  
        <a-row :gutter="24">
           <a-col :span="24">
            <a-form-model-item :label="$t('备注')" prop="remark">
              <a-textarea v-model="model.constructionDetail.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
            </a-form-model-item>
          </a-col>
        </a-row>  

      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction,postAction } from '@/api/manage'
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  import Detail from '../detail'
  export default {
    name: 'ConstructionDetailForm',
    components: {
      JUpload,
      Detail
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model:{
         },
        confirmLoading: false,
        showDetail: false,
        remarkRequired: false,
        url: {
          add: "/jeecg-engineering/engineering/constructionDetail/add",
          edit: "/jeecg-engineering/engineering/constructionDetail/edit",
          queryById: "/jeecg-engineering/ticket/tickets/queryById",
          pass: "/jeecg-engineering/flowable/task/completeByDateId",
          list: "/jeecg-engineering/engineering/constructionDetail/list",
          upload: "sys/common/upload",
          // userList: "/jeecg-engineering/flowable/definition/userList",
          userList: "/jeecg-engineering/ticket/ticketsUser/list",
          reject: "/jeecg-engineering/flowable/task/taskRejectByDataId",
          editApproverName: "/jeecg-engineering/ticket/tickets/editApproverName"
        },
        fileList: [],
        fileList2: [],
        ticketsData: {},
        bool: false,
        candidateUsersList:[]
      }
    },
    computed: {
      formDisabled(){
        return this.disabled
      },
      validatorRules () {
        let validateConstructionAnnex = (rule,value,callback)=>{
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请上传施工附件')));
          }
        }
        let validateAcceptanceAnnex = (rule,value,callback)=>{
          if(value){
            callback();
          }else{
            callback(new Error(this.$t('请上传验收附件')));
          }
        }
        return {
          audit:{ required: true,message: this.$t('请选择审批意见'), trigger: 'change' },
          remark:{ required: this.remarkRequired,message: this.$t('请输入备注'),trigger: 'input' },
          isDesignChanges: [{ required: true, message: this.$t('请选择是否存在设计变更') }],
          constructionAnnex: [{ required: true, validator: validateConstructionAnnex, trigger: 'change' }],
          acceptanceAnnex: [{ required: true, validator: validateAcceptanceAnnex, trigger: 'change' }],
          candidateUsers:{ required: true,message: this.$t('请选择下一节点操作人'), trigger: 'change' }
        }
      },
    },
    watch:{
      'model.audit':{
        handler(val){
          if(val == 1){
            this.remarkRequired = false;
          }else{
            this.remarkRequired = true;
          }
        }
      }
    },
    created () {
       //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      getUserList(){
        getAction(this.url.userList,{pageSize:999}).then(res=>{
          if(res.success){
            this.candidateUsersList = res.result.records;
          }
        })
      },
      uploadChange(file){
        // this.model.constructionAnnex = file;
        this.$set(this.model.constructionDetail,'constructionAnnex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('constructionAnnex');
        })
      },
      uploadChange2(file){
        // this.model.constructionAnnex = file;
        this.$set(this.model.constructionDetail,'acceptanceAnnex',file);
        this.$nextTick(()=>{
          this.$refs.form.validateField('acceptanceAnnex');
        })
      },
      add () {
        this.edit(this.modelDefault);
      },
      edit (record,bool) {
        let that = this;
        
        this.bool = bool;
        this.model = Object.assign({});
        // 清除表单验证
        this.$nextTick(()=>{
          this.$refs.form.clearValidate();
        })

        if(record.id){
          // 获取详情信息
          getAction(this.url.queryById,{id:record.id}).then(res=>{
            if(res.success){
              that.ticketsData = { ...res.result }
              // 报装 设计预算信息
              that.model = { 
                ...res.result.installationDetail,
                // dataId:  res.result.id,
                // installationId:  res.result.ticketsForeignId,
                // ticketsId:  res.result.id,
               }
               if (that.model.constructionDetail.constructionAnnex == null) {
                  that.fileList = []
                } else {
                  that.fileList = [that.model.constructionDetail.constructionAnnex];
                }
               if (that.model.constructionDetail.acceptanceAnnex == null) {
                  that.fileList2 = []
                } else {
                  that.fileList2 = [that.model.constructionDetail.acceptanceAnnex];
                }

                // 确保子组件已挂载
                that.$nextTick(() => {
                  if(that.$refs.detailRef) {
                    that.$refs.detailRef.init(that.ticketsData, bool);
                    that.showDetail = true;
                  } else {
                    console.error('子组件引用不存在');
                  }
                });
            }
          })
        }

        this.getUserList();
        this.visible = true;
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let httpurl = this.url.pass;
            let method = 'post';
            let message = this.$t('处理成功');

            let params = {
                dataId: that.ticketsData.id,
                createTicketDTO:{
                  ticketsInstallationReq: {
                    ...that.model
                  },
                },
                comment: ''
              }

            httpAction(httpurl,params,method).then((res) => {
              if (res.success) {
                that.$message.success(message);
                that.$emit('ok');
                this.visible = false;
              } else {
                that.$message.warning(res.message);
              }
              that.confirmLoading = false;
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
        })
      },
    }
  }
</script>
<style>
  .lab-title{
    font-weight: bold;
    color: #000;
  }
</style>